<div class="view-ad-container">
  <button class="btn close-btn" (click)="close()" style="position: absolute; top: 10px; right: 10px;">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
  <!-- Top Image with Status Badge -->
  <div class="image-container mt-3">
    <img *ngIf="!isImageError" class="ad-img" [appImageSrc]="ad?.media" (error)="onImageError($event)" />

    <!-- Add a placeholder or empty state -->
    <div *ngIf="isImageError" class="empty-state text-center py-5">
      <div class="empty-state-content">
        <i class="fe fe-image fa-3x mb-3 text-muted"></i>
        <h5 class="text-muted">Image Not Available</h5>
      </div>
    </div>
    <label class="typeBadge">{{ ad.status | adStatusPipe }}</label>
  </div>

  <!-- Ad Details Section -->
  <div class="details">
    <span class="companyName">BY {{ ad.companyName }}</span>

    <h2 class="title">
      {{ ad.title }}
      <span class="category">{{ (ad.category | category | async) }}</span>
    </h2>

    <p class="description">{{ ad.description }}</p>
    <div class="metadata-section">
      <div class="metadata-item" *ngIf="ad.providerName">
        <label>Provider</label>
        <span class="linkUrl" (click)="modalService.dismissAll()"
          routerLink="/providers/view-provider/{{ad.providerID}}">{{ ad.providerName }}</span>
      </div>
      <div class="metadata-item">
        <label>Phone</label>
        <span>{{ ad.phoneNumber }}</span>
      </div>
      <div class="metadata-item">
        <label>Email</label>
        <span>{{ ad.email }}</span>
      </div>
      <div class="metadata-item">
        <label>Link</label>
        <span>{{ ad.link }}</span>
      </div>
      <div class="metadata-item">
        <label>Created By</label>
        <span>{{ ad.createdBy }}</span>
      </div>
      <div class="metadata-item">
        <label>Creation Date</label>
        <span>{{ ad.creationDate | date: 'fullDate' }}</span>
      </div>
    </div>

    <!-- Buttons -->
    <div class="footer d-flex flex-wrap gap-2">
      <ng-container *hasPermission="'ads.edit'">
        <button class="btn me-2" [ngClass]="ad.status == 1 ? 'btn-danger' : 'btn-success'" [disabled]="isSaving"
          (click)="toggleAdStatus()">
          {{ ad.status == 1 ? 'Deactivate' : 'Activate' }} Ad
        </button>
        <button class="btn link-btn me-2" [disabled]="isSaving" (click)="openModal(AddLinkModal, $event)">
          {{ ad?.link == null ? "Add" : "Change" }} Link
        </button>
      </ng-container>
      <button *hasPermission="'ads.delete'" type="button" class="btn btn-outline-danger" [disabled]="isSaving"
        (click)="deleteAd()">
        <i class="fe fe-trash-2 me-1" aria-hidden="true"></i>
        Delete Ad
      </button>
    </div>
  </div>
</div>

<!-- Modal Template for Link -->
<ng-template #AddLinkModal let-modal>
  <div class="modal-centered" style="width: 100%;">
    <div class="modal-content" style="min-height: 200px;">
      <div class="modal-header">
        <h5 class="modal-title">{{ad?.link == null ? "Add" : "Change"}} Link</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [formGroup]="linkForm">
        <input type="text" class="form-control text-black" formControlName="link" placeholder="Enter Link" />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-o" (click)="modal.dismiss('Cross click')">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="linkForm.value.link == '' || isSaving"
          (click)="addLink()">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span *ngIf="!isSaving">Save</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

